import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const AccessibilityHelper = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Önceden eklenmiş buton varsa temizle (HMR / strict-mode çift mount'u önle)
    const existing = document.getElementById('skip-to-main-btn');
    if (existing) existing.remove();

    const skipButton = document.createElement('button');
    skipButton.id = 'skip-to-main-btn';
    skipButton.textContent = t('skipToMainContent');
    skipButton.className =
      'sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 ' +
      'bg-amber-600 text-white text-sm font-semibold px-4 py-2 rounded-xl z-[9999]';

    // Sadece klavye tıklamasında (Enter / Space) çalış — mouse tıklamasında scroll etme
    skipButton.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      const main =
        document.querySelector('main') ||
        document.querySelector('[role="main"]');
      if (main) {
        // tabIndex yoksa focus alabilmesi için geçici ekle
        if (!main.hasAttribute('tabindex')) {
          main.setAttribute('tabindex', '-1');
        }
        main.focus({ preventScroll: false });
      }
    });

    document.body.insertBefore(skipButton, document.body.firstChild);

    return () => {
      skipButton.remove();
    };
  }, [t]);

  return null;
};

export default AccessibilityHelper;
